import { render, staticRenderFns } from "./TaskListOrderTaskPop.vue?vue&type=template&id=1a2ad0a2&"
import script from "./TaskListOrderTaskPop.vue?vue&type=script&lang=js&"
export * from "./TaskListOrderTaskPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports